import reasons from '../constants/reasons';

const isAutomationReason = (actionType) => Object.values(reasons).includes(actionType);

export default isAutomationReason;
